import { useQuery } from '@tanstack/react-query';
import { http, returnIfNotFoundError } from 'services/http';
import { FAVORITES_GET_MANY } from 'api/query-keys.ts';
import type { FavoriteRes } from 'api/swagger';
import type { FavoriteCounts, FavoritesRecord, IFavoritesData } from './types';

const transformFavorites = (favorites: FavoriteRes[]): IFavoritesData => {
  const favoriteRecords: FavoritesRecord = {};
  const favoriteCounts: FavoriteCounts = {};

  favorites.forEach((favorite) => {
    if (!favoriteRecords[favorite.cargoId]) {
      favoriteRecords[favorite.cargoId] = [];
    }
    favoriteRecords[favorite.cargoId].push(favorite.color);

    favoriteCounts[favorite.color] = (favoriteCounts[favorite.color] ?? 0) + 1;
  });

  return { favoriteRecords, favoriteCounts };
};

export const useGetFavorites = () => {
  return useQuery<IFavoritesData>({
    queryKey: [FAVORITES_GET_MANY],
    queryFn: async () => {
      try {
        const { data } = await http.get<FavoriteRes[]>(`/v1/favorites/`);
        const transformedData = transformFavorites(data);

        return transformedData;
      } catch (error) {
        return returnIfNotFoundError(error, { favoriteRecords: null, favoriteCounts: null });
      }
    },
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};
